import { render, staticRenderFns } from "./productCategoryForm.vue?vue&type=template&id=68ba80be"
import script from "./productCategoryForm.vue?vue&type=script&lang=js"
export * from "./productCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports